import { firstLetterTolowerCase } from "../utils/utils";

export class ValidationProvider {
  static isValid(formRef) {
    const formComp = formRef.current;

    formComp.validateAll();
    let errors = this._getErrors(formComp);

    if (errors) {
      let invalidComp = formComp.state.byId[errors[0]];

      document.getElementById(invalidComp.id).scrollIntoView(true);
    }

    return !errors || errors.length === 0;
  }

  static isValidWithoutValidation(formRef) {
    const formComp = formRef.current;

    let errors = this._getErrors(formComp);

    return !errors || errors.length === 0;
  }

  static _getErrors = (component) => {
    const context = component.getChildContext();

    if (context._errors && context._errors.length > 0) {
      return context._errors;
    }
  };
}

export const createValidationErrorsObject = (validationErrors) => {
  var validationErrorsObject = {};
  if (validationErrors) {
    for (var i = 0; i < validationErrors.length; i++) {
      var validationError = validationErrors[i];

      if (validationError.Field.includes(".")) {
        validationErrorsObject[
          firstLetterTolowerCase(validationError.Field).split(".")[1]
        ] = validationError.Messages[0];
      } else {
        validationErrorsObject[firstLetterTolowerCase(validationError.Field)] =
          validationError.Messages[0];
      }
    }
  }

  return validationErrorsObject;
};
